document.addEventListener('DOMContentLoaded', () => {
    const oFooterNode = document.querySelector('.footer');

    yaReachGoalObserver(oFooterNode, 'view_footer');
});